import React, { useState, useCallback } from "react";
import { Button, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReservationComponent from "./ReservationComponent";

const ReservationDialog = ({ placeId, userId, authToken, isAuthenticated, refetchPlaceData }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        sx={{ my: 1 }}
      >
        Book your spot
      </Button>
      <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ position: 'relative' }}>
          Book Your Spot
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ReservationComponent
            placeId={placeId}
            userId={userId}
            authToken={authToken}
            refetchPlaceData={refetchPlaceData}
            onClose={handleClose}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ReservationDialog;
